import { IconsInitConfigType } from '@shared-ui-kit';
import { AdminPermission, CarrierPermission, CustomerPermission } from '@data-access';

export interface SideNavigationItem {
  icon: IconsInitConfigType;
  title: string;
  routerLink: string;
  dividerAfter?: boolean;
  requiredPermissions?: string[];
}

interface AdminSideNavigationItem extends SideNavigationItem {
  requiredPermissions?: AdminPermission[];
}

interface CustomerSideNavigationItem extends SideNavigationItem {
  requiredPermissions?: CustomerPermission[];
}

interface CarrierSideNavigationItem extends SideNavigationItem {
  requiredPermissions?: CarrierPermission[];
}

export const ADMIN_SIDE_NAVIGATION_ITEMS: AdminSideNavigationItem[] = [
  {
    icon: 'van-new-20',
    title: 'common.navigationItems.newRegistrations',
    routerLink: 'new-carriers',
    requiredPermissions: ['CARRIER_REGISTRATION_READ', 'CARRIER_REGISTRATION_FULL'],
  },
  {
    icon: 'van-20',
    title: 'common.navigationItems.carriers',
    routerLink: 'carriers',
    requiredPermissions: ['CARRIER_REGISTERED_READ', 'CARRIER_REGISTERED_FULL'],
    dividerAfter: true,
  },
  {
    icon: 'load-20',
    title: 'common.navigationItems.loads',
    routerLink: 'loads',
    requiredPermissions: ['LOAD_READ', 'LOAD_FULL'],
  },
  {
    icon: 'map-20',
    title: 'common.navigationItems.vehicleMap',
    routerLink: 'vehicle-map',
    requiredPermissions: ['MAP_READ'],
    dividerAfter: true,
  },
  {
    icon: 'shipper-20',
    title: 'common.navigationItems.customers',
    routerLink: 'customers',
    requiredPermissions: ['CUSTOMER_READ', 'CUSTOMER_FULL'],
    dividerAfter: true,
  },
  {
    icon: 'group-20',
    title: 'common.navigationItems.users',
    routerLink: 'users',
    requiredPermissions: ['USERS_READ', 'USERS_FULL'],
  },
  {
    icon: 'manager-20',
    title: 'common.navigationItems.managers',
    routerLink: 'managers',
    requiredPermissions: ['MANAGERS_READ', 'MANAGERS_FULL'],
  },
];

const CARRIER_FLEET_OWNER_SIDE_NAVIGATION_ITEMS_dev: CarrierSideNavigationItem[] = [
  {
    icon: 'van-16',
    title: 'common.navigationItems.units',
    routerLink: 'fleet-board',
    requiredPermissions: ['FLEET_BOARD_READ', 'FLEET_BOARD_FULL'],
  },
  {
    icon: 'load-20',
    title: 'common.navigationItems.loads',
    routerLink: 'loads',
    requiredPermissions: ['LOAD_READ', 'LOAD_FULL'],
  },
  {
    icon: 'shipper-20',
    title: 'common.navigationItems.directCustomers',
    routerLink: 'customers',
    requiredPermissions: ['DIRECT_CUSTOMER_READ', 'DIRECT_CUSTOMER_FULL'],
  },
  {
    icon: 'profile-20',
    title: 'common.navigationItems.profile',
    routerLink: 'profile',
    requiredPermissions: ['PROFILE_READ', 'PROFILE_FULL'],
  },
  {
    icon: 'revenue-20',
    title: 'common.navigationItems.earning',
    routerLink: 'earning',
    requiredPermissions: ['PROFILE_READ', 'PROFILE_FULL'],
  },
  {
    icon: 'group-20',
    title: 'common.navigationItems.users',
    routerLink: 'users',
    requiredPermissions: ['USERS_READ', 'USERS_FULL'],
  },
];

const CARRIER_FLEET_OWNER_SIDE_NAVIGATION_ITEMS_prod: CarrierSideNavigationItem[] = [
  {
    icon: 'van-16',
    title: 'common.navigationItems.units',
    routerLink: 'fleet-board',
    requiredPermissions: ['FLEET_BOARD_READ', 'FLEET_BOARD_FULL'],
  },
  {
    icon: 'load-20',
    title: 'common.navigationItems.loads',
    routerLink: 'loads',
    requiredPermissions: ['LOAD_READ', 'LOAD_FULL'],
  },
  {
    icon: 'shipper-20',
    title: 'common.navigationItems.directCustomers',
    routerLink: 'customers',
    requiredPermissions: ['DIRECT_CUSTOMER_READ', 'DIRECT_CUSTOMER_FULL'],
  },
  {
    icon: 'profile-20',
    title: 'common.navigationItems.profile',
    routerLink: 'profile',
    requiredPermissions: ['PROFILE_READ', 'PROFILE_FULL'],
  },
  {
    icon: 'group-20',
    title: 'common.navigationItems.users',
    routerLink: 'users',
    requiredPermissions: ['USERS_READ', 'USERS_FULL'],
  },
];

// old CARRIER_FLEET_OWNER_SIDE_NAVIGATION_ITEMS
export function getCarrierFleetOwnerSideNavigationItems(
  isDev: boolean,
): CarrierSideNavigationItem[] {
  return isDev
    ? CARRIER_FLEET_OWNER_SIDE_NAVIGATION_ITEMS_dev
    : CARRIER_FLEET_OWNER_SIDE_NAVIGATION_ITEMS_prod;
}

export const CARRIER_OWNER_OPERATOR_SIDE_NAVIGATION_ITEMS: CarrierSideNavigationItem[] = [
  {
    icon: 'profile-20',
    title: 'common.navigationItems.profile',
    routerLink: 'profile',
    requiredPermissions: ['PROFILE_READ', 'PROFILE_FULL'],
  },
];

export const CUSTOMER_SIDE_NAVIGATION_ITEMS: CustomerSideNavigationItem[] = [
  {
    icon: 'load-20',
    title: 'common.navigationItems.loads',
    routerLink: 'loads',
    requiredPermissions: ['LOAD_READ', 'LOAD_FULL'],
  },
  {
    icon: 'profile-20',
    title: 'common.navigationItems.companyInfo',
    routerLink: 'profile',
    requiredPermissions: ['COMPANY_INFO_READ', 'COMPANY_INFO_FULL'],
  },
  {
    icon: 'map-20',
    title: 'common.navigationItems.vehicleMap',
    routerLink: 'vehicle-map',
    requiredPermissions: ['MAP_READ'],
  },
  {
    icon: 'group-20',
    title: 'common.navigationItems.users',
    routerLink: 'users',
    requiredPermissions: ['USERS_READ', 'USERS_FULL'],
  },
];
